/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Body1Inputs */

const en_minifier_body1 = /** @type {(inputs: Minifier_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minifying JSON removes the spaces, tabs, and line breaks that sit between tokens. Whitespace inside string values is untouched, because it is data rather than formatting. What is left is the shortest byte sequence that still parses to the same structure, which is what you want to store in a cache, put in a database column, or return from an endpoint.`)
};

const ko_minifier_body1 = /** @type {(inputs: Minifier_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 압축은 토큰 사이에 있는 공백, 탭, 줄바꿈을 제거합니다. 문자열 값 안의 공백은 서식이 아니라 데이터이므로 손대지 않습니다. 남는 것은 같은 구조로 파싱되는 가장 짧은 바이트 열이며, 캐시에 저장하거나 데이터베이스 컬럼에 넣거나 엔드포인트에서 반환할 때 원하는 형태입니다.`)
};

const ja_minifier_body1 = /** @type {(inputs: Minifier_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON の圧縮はトークンの間にある空白、タブ、改行を取り除きます。文字列値の中の空白は書式ではなくデータなので手を付けません。残るのは同じ構造にパースされる最短のバイト列で、キャッシュに保存する、データベースの列に入れる、エンドポイントから返す、といった用途で欲しい形です。`)
};

/**
* | output |
* | --- |
* | "Minifying JSON removes the spaces, tabs, and line breaks that sit between tokens. Whitespace inside string values is untouched, because it is data rather tha..." |
*
* @param {Minifier_Body1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_body1 = /** @type {((inputs?: Minifier_Body1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Body1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_body1(inputs)
	if (locale === "ko") return ko_minifier_body1(inputs)
	return ja_minifier_body1(inputs)
});